// react
import { useDispatch } from 'react-redux';

// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import {
  createFileRoute,
  useNavigate,
  useParams,
} from '@tanstack/react-router';

// material ui
import { Container } from '@mui/material';

// shared components
import { WritableOnly } from '@/components/access-control';
import PageHeader from '@/components/layout/PageHeader';

// feature-components
import CreateEnergyGroupForm from '@/features/energyxplorer/forms/CreateEnergyGroupForm';
// components
import { showSnackbar } from '@/redux/snackbarSlice';
import ErrorBoundary from '@/routes/-ErrorBoundary.tsx';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/deepdive/create',
)({
  component: RouteComponent,
  errorComponent: ErrorBoundary,
  staticData: {
    crumb: 'common:actions.create',
    hideEnergyAnalysisAppBar: true,
  },
});

function RouteComponent() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { accountId } = useParams({ strict: false });
  const { t } = useTranslation('energyxplorer');

  const handleSuccess = (energyGroup) => {
    dispatch(
      showSnackbar({
        message: t('energy_group_create_form.snackbar_success_create'),
        severity: 'success',
      }),
    );
    navigate({
      to: `/$accountId/energyxplorer/deepdive/${energyGroup.energyGroupId}/create-first-node`,
    });
  };

  const handleCancel = () => {
    navigate({ to: '/$accountId/energyxplorer' });
  };

  return (
    <Container maxWidth="md" sx={{ py: 2 }}>
      <PageHeader title={t('energy_group_create_form.step1.title')} />
      <WritableOnly>
        <CreateEnergyGroupForm
          accountId={Number(accountId)}
          onSuccess={handleSuccess}
          onCancel={handleCancel}
        />
      </WritableOnly>
    </Container>
  );
}
